/** @jsxImportSource @emotion/react */
/* eslint-disable react/jsx-props-no-spreading,jsx-a11y/label-has-associated-control,react/prop-types */
import { ReactComponent as InfoIcon } from "assets/icons/InformationHeader.svg";
import { columnGap4Css } from "assets/css/gaps.css";
import { errorCss, labelCss } from "assets/css/fieldset.css";
import Popper from "components/common/Popper";
import { inputCss } from "components/common/Input/index.css";
import {
  alignedTextAreaCss,
  iconCss,
  smallerTextArea,
  textAreaContainerCss,
  textAreaCss,
} from "./index.css";

export default function TextArea({ register, errorMessage, label, smallSize, name, popperText }) {
  const hasAlignedSizing = label === "Key Metrics" || label === "Value Propositions";
  let textAreaStyling;
  if (hasAlignedSizing) {
    textAreaStyling = alignedTextAreaCss;
  } else if (smallSize) {
    textAreaStyling = smallerTextArea;
  } else {
    textAreaStyling = textAreaCss;
  }

  return (
    <div css={textAreaContainerCss}>
      <div className="flex-a-c-j-st" css={columnGap4Css}>
        <label htmlFor={name} css={labelCss}>
          {label}
        </label>
        {popperText && (
          <Popper text={popperText} placement="top">
            <InfoIcon css={iconCss} />
          </Popper>
        )}
      </div>

      <textarea
        className="text"
        css={[textAreaStyling, inputCss({ error: errorMessage })]}
        id={name}
        name={name}
        placeholder={label}
        {...register(name)}
      />

      {errorMessage && <span css={errorCss}>{errorMessage}</span>}
    </div>
  );
}
